import { zUid } from "src/types/zUid";
import z from "zod";

const zBadComponent = z.object({
  componentName: z.string(),
  componentEntityId: zUid,
});

export const zBadCalculatePlanning2 = z.object({
  faults: zBadComponent.array(),
});

export type ZBadCalculatePlanning2 = z.infer<typeof zBadCalculatePlanning2>;

export const zBadComponentsResponse = zBadCalculatePlanning2.or(
  zBadComponent.array(),
);
